import { cbi_reference_area_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiReferenceAreaEnum = (enumValue: cbi_reference_area_enum) => {
  switch (enumValue) {
    case cbi_reference_area_enum.COMMON_AREA:
      return <Trans i18nKey="Enum_CbiReferenceAreaEnum-COMMON_AREA" />;
    case cbi_reference_area_enum.TENANT_AREA:
      return <Trans i18nKey="Enum_CbiReferenceAreaEnum-TENANT_AREA" />;
    case cbi_reference_area_enum.WHOLE_BUILDING:
      return <Trans i18nKey="Enum_CbiReferenceAreaEnum-WHOLE_BUILDING" />;
  }
};

export const translateCbiReferenceAreaEnum_dynamic = (enumValue: cbi_reference_area_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_reference_area_enum.COMMON_AREA:
      return t('Enum_CbiReferenceAreaEnum-COMMON_AREA');
    case cbi_reference_area_enum.TENANT_AREA:
      return t('Enum_CbiReferenceAreaEnum-TENANT_AREA');
    case cbi_reference_area_enum.WHOLE_BUILDING:
      return t('Enum_CbiReferenceAreaEnum-WHOLE_BUILDING');
  }
};
